"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localAsBase64 = localAsBase64;

function localAsBase64(blobInfo, success) {
  success("data:".concat(blobInfo.blob().type, ";base64,").concat(blobInfo.base64()));
}